import React, { Component } from "react";
import { Form, Field } from "react-final-form";

import FormInput from "Components/FormInput/FormInput";
import FormTextArea from "Components/FormTextArea";
import Button from "Components/Button";
import LoadingIcon from "Components/LoadingIcon";

import { FormError, FormSuccess } from "Themes/StyledComponents";

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.message) {
    errors.message = "Required";
  }
  return errors;
};

class ContactUsForm extends Component {
  render() {
    const { handleSubmit, fetching, success, error } = this.props;
    return (
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name={"email"}
              render={(props) => {
                return <FormInput {...props} placeholder={"Email"} />;
              }}
            />
            <Field
              name={"message"}
              render={(props) => {
                return (
                  <FormTextArea
                    {...props}
                    placeholder={"Write your message here"}
                  />
                );
              }}
            />
            <Button type={"submit"}>{fetching ? <LoadingIcon /> : "Send"}</Button>
            {error && <FormError>Oops...there was an error</FormError>}
            {success && <FormSuccess>Success - message sent!</FormSuccess>}
          </form>
        )}
      />
    );
  }
}

export default ContactUsForm;
